import React from 'react'
import { LosseLayout, useLosseLayout } from '@ubo/losse-sjedel'
import Footer from './Footer'
import Header from './Header'
import NewsLetter from '../elements/NewsLetter'

export default function Layout({ children }: React.PropsWithChildren<{}>) {
  return (
    <LosseLayout>
      <NewsLetter />
      <Content>{children}</Content>
    </LosseLayout>
  )
}

function Content({ children }: React.PropsWithChildren<{}>) {
  const { isScrollable } = useLosseLayout()

  return (
    <div className={`${isScrollable ? `h-full` : `h-screen overflow-hidden`}`}>
      <Header />
      <main className="relative min-h-screen overflow-x-hidden pt-[40px] lg:pt-0 max-w-[2200px] mx-auto">{children}</main>
      <Footer />
    </div>
  )
}
